import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import { API, axios } from "@/lib/api";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const BlogTeaser = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts`).then(({ data }) => setPosts(data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section className="py-24 md:py-32" data-testid="blog-teaser">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-14">
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport}>
            <p className="text-[#ccff00] text-xs font-semibold uppercase tracking-widest mb-4">From the blog</p>
            <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight">
              Get found. Get booked.
            </h2>
          </motion.div>
          <Link to="/blog" className="inline-flex items-center gap-2 text-white hover:text-[#ccff00] transition-colors font-medium" data-testid="blog-teaser-all">
            Read all articles <ArrowRight size={18} />
          </Link>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid md:grid-cols-3 gap-6">
          {posts.map((p) => (
            <motion.div key={p.id} variants={fadeUp}>
              <Link to={`/blog/${p.slug}`} className="group block rounded-2xl overflow-hidden bg-[#121212] border border-white/10 hover:border-[#ccff00]/40 transition-colors h-full" data-testid={`teaser-post-${p.slug}`}>
                <div className="h-44 overflow-hidden">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs text-zinc-500 mb-3">
                    <span className="text-[#ccff00] uppercase tracking-widest">{p.category}</span>
                    <span className="flex items-center gap-1"><Clock size={12} /> {p.read_time} min</span>
                  </div>
                  <h3 className="font-display font-bold text-lg leading-snug mb-2 group-hover:text-[#ccff00] transition-colors">{p.title}</h3>
                  <p className="text-sm text-zinc-400 line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default BlogTeaser;
